import { render, staticRenderFns } from "./TransferConfig.vue?vue&type=template&id=01bb49cf&"
import script from "./TransferConfig.vue?vue&type=script&lang=js&"
export * from "./TransferConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports